import TrackedLink from "./TrackedLink";

export default function SiteHeader() {
  return (
    <header className="site-header">
      <a className="wordmark" href="/" aria-label="Ebrahim Ahmadivarzaneh, home">
        EA<span>/</span>
      </a>
      <p className="header-speciality">AWS · Platform · Networking</p>
      <nav aria-label="Primary navigation">
        <a href="/#services">Services</a>
        <a href="/#work">Work</a>
        <a href="/#about">About</a>
        <TrackedLink
          className="header-cta"
          href="#contact"
          eventName="Contact CTA Click"
          eventProps={{ location: "header" }}
        >
          Let&apos;s talk
        </TrackedLink>
      </nav>
    </header>
  );
}
